import { Switch, Match } from 'solid-js';
import { HomeIcon } from '../../icons-library/product/home';
import { GoIcon } from '../../icons-library/product/go';
import { ProductIconsProps } from './product-icon-tab-types';
import { EnergyIcon } from '../../icons-library/product/energy';
import { FreeHandsIcon } from '../../icons-library/product/free-hands';
import { NightHMEIcon } from '../../icons-library/product/night-hme';
import { ProtectIcon } from '../../icons-library/product/protect';
import { ShowerIcon } from '../../icons-library/product/shower';
import { NightAdhesiveIcon } from '../../icons-library/product/night-adhesive';
import { StandardAdhesiveIcon } from '../../icons-library/product/standard-adhesive';
import { StabilityAdhesiveIcon } from '../../icons-library/product/stability-adhesive';
import { SensitiveAdhesiveIcon } from '../../icons-library/product/sensitive';
import { LarytubeIcon } from '../../icons-library/product/larytube';
import { LarybuttonIcon } from '../../icons-library/product/larybutton';
import { TracoeNeonatesIcon } from '../../icons-library/product/tracoe-neonates';
import { TracoePediatrictsIcon } from '../../icons-library/product/tracoe-pediatrics';
import { ComfortIcon } from '../../icons-library/product/comfort';
import { OxygenIcon } from '../../icons-library/product/oxygen';

export const ProductIcons = (props: ProductIconsProps) => {
    const size = props.size ?? 3.57;

    return (
        <Switch>
            <Match when={props.name === 'home'}>
                <HomeIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'go'}>
                <GoIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'energy'}>
                <EnergyIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'free-hands'}>
                <FreeHandsIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'night-hme'}>
                <NightHMEIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'protect'}>
                <ProtectIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'shower'}>
                <ShowerIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'night-adhesive'}>
                <NightAdhesiveIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'standard-adhesive'}>
                <StandardAdhesiveIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'stability-adhesive'}>
                <StabilityAdhesiveIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'sensitive-adhesive'}>
                <SensitiveAdhesiveIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'larytube'}>
                <LarytubeIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'larybutton'}>
                <LarybuttonIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'oxygen'}>
                <OxygenIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'tracoe-neonates'}>
                <TracoeNeonatesIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'tracoe-pediatric'}>
                <TracoePediatrictsIcon width={size} height={size} />
            </Match>
            <Match when={props.name === 'comfort'}>
                <ComfortIcon width={size} height={size} />
            </Match>
        </Switch>
    );
};
